import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UiTable } from 'src/ui';
import propTypes from 'prop-types';

export function AllowedReportsTable({
  people,
  loading,
  setSelectedPerson,
  selectedPerson,
}) {
  /* eslint-disable react/prop-types */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  const tableColumns = [
    {
      Header: () => (
        <span className="icon is-small table-header-member-icon">
          <FontAwesomeIcon icon={['fas', 'user-circle']} size="2x" />
        </span>
      ),
      Cell: ({ original }) => (
        <div className={`person-status ${original.statusClassName}`}>
          <span
            role="button"
            tabIndex={0}
            className="icon hidden-hover"
            onClick={() => setSelectedPerson(original)}
          >
            <FontAwesomeIcon icon={['fas', 'user-circle']} size="2x" />
            {original.isAdmin && (
              <span className="icon-tag hidden-hover">
                <FontAwesomeIcon icon={['fas', 'star']} />
              </span>
            )}
          </span>
        </div>
      ),
      sortable: false,
      width: 65,
      resizable: false,
    },
    {
      Header: 'Person',
      accessor: 'name',
      Cell: ({ original, value }) => (
        <div className="member-name">
          <div>
            <span
              role="button"
              tabIndex={0}
              onClick={() => setSelectedPerson(original)}
              className="hidden-hover"
            >
              {value}
            </span>

            {original.isSigner && (
              <span className="icon is-small has-text-grey">
                <FontAwesomeIcon icon={['far', 'signature']} />
              </span>
            )}
          </div>
          <small className="has-text-grey-medium-dark hidden-hover">
            {original.title && `${original.title} | `}
            {original.emailAddress}
          </small>
        </div>
      ),
    },

    {
      Header: 'Type',
      accessor: 'type',
      Cell: row => (
        <small className="has-text-grey-medium-dark is-block has-text-centered">
          {row.value}
        </small>
      ),
    },
    {
      Header: 'Allowed Reports',
      Cell: ({ original }) => (
        <small
          role="button"
          tabIndex={0}
          className="has-text-grey-medium-dark is-block has-text-centered hidden-hover"
          onClick={() => setSelectedPerson(original)}
        >
          {original.allowedReports ? original.allowedReports.length : 0}
        </small>
      ),
      sortable: true,
      resizable: true,
    },
  ];
  /* eslint-enable */

  return (
    <UiTable
      className="people-table -highlight"
      columns={tableColumns}
      loading={loading}
      data={people}
      useTablePagination
      title="People"
      resolveData={data =>
        data.map(transaction => ({
          ...transaction,
        }))
      }
      getTrProps={(state, rowInfo) => {
        if (rowInfo && rowInfo.row) {
          return {
            onClick: () => {
              setSelectedPerson(rowInfo.original);
            },
            style: {
              background:
                rowInfo.original.id === selectedPerson.id ? '#d7dbea' : 'white',
            },
          };
        } return {};
      }}
      hidePrev
      hideNext
      hideButton
    />
  );
}
AllowedReportsTable.defaultProps = {
  loading: false,
};
AllowedReportsTable.propTypes = {
  loading: propTypes.bool,
  people: propTypes.array.isRequired,
  setSelectedPerson: propTypes.func.isRequired,
  selectedPerson: propTypes.object.isRequired,
};
